import { SubmittedForm } from '~/forms/types';
import { User } from '~/users/types';
import { WorkSite } from '~/worksites/types';

export enum ColorEnum {
  Open = 'yellow',
  Resolved = 'green',
  Overdue = 'red',
}

export interface CorrectiveAction {
  assignDate: string;
  assignedUserID?: string | null;
  assignedUsers?: {
    data: User[];
  };
  createdBy?: {
    data: User;
  } | null;
  isAssigned?: string;
  comments: string | null;
  description: string | null;
  eventID?: string | null;
  id?: string;
  name: string;
  reportDate: string;
  requiredApprovals: number | null;
  resolveDate: string | null;
  resolved: number;
  resolvedBy: User['userID'][] | null;
  resolvedFormID: string | null;
  sourceID: string | null;
  sourceType: string | null;
  submittedFormID: SubmittedForm['submittedFormID'] | null;
  targetDate: string | null;
  worksiteID: WorkSite['sharedID'];
  status?: string;
  submittedForm?: { data: SubmittedForm } | null;
  worksite?: {
    data: WorkSite;
  };
}

export interface CorrectiveActionForm {
  assignedUsers: Array<User['userID']>;
  comments: string;
  targetDate: string;
  resolved: boolean;
}

export interface Filter {
  worksites: Array<WorkSite['sharedID']>;
  status: string | null;
  forms: Array<SubmittedForm['submittedFormID']>;
  assignedUsers: Array<User['userID']>;
}

export enum ActionStatusEnum {
  Open = 'Open',
  Resolved = 'Resolved',
  Overdue = 'Overdue',
}
